var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex w-100 d-block bg-white p-1"},[_c('div',{staticClass:"position-relative ml-3 mr-3"},[_c('span',{class:_vm.iconClass,domProps:{"innerHTML":_vm._s(_vm.setIcon)}})]),_c('div',{staticClass:"h6 mb-0"},[_c('p',{staticClass:"mb-0 msg-style",domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }